import { useEffect } from "react";
import { useTheme } from "@mui/material";

/* global WhWidgetSendButton */

const WhatsAppWidget = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  // Function to apply theme styles to WhatsApp widget
  const applyThemeStyles = () => {
    const widget = document.getElementById("getbutton-widget");
    if (!widget) return;

    const bgColor = theme.palette.background.paper;
    const textColor = theme.palette.text.primary;
    const borderColor = theme.palette.divider;

    const button = widget.querySelector(".gb-button") || widget.querySelector("button") || widget.querySelector("a");
    if (button) {
      button.style.backgroundColor = bgColor;
      button.style.color = textColor;
      if (button.style.border || button.getAttribute("style")?.includes("border")) {
        button.style.borderColor = borderColor;
      }
    }

    // Also style any popup/panel elements
    const popup = widget.querySelector(".gb-popup") || widget.querySelector(".gb-panel") || widget.querySelector(".gb-widget-container");
    if (popup) {
      popup.style.backgroundColor = bgColor;
      popup.style.color = textColor;
    }

    // Style text elements inside widget
    const textElements = widget.querySelectorAll("span, p, div");
    textElements.forEach((el) => {
      if (el.textContent && el.textContent.trim().length > 0 && !el.closest("svg")) {
        el.style.color = textColor;
      }
    });
  };

  useEffect(() => {
    (function () {
      var options = {
        whatsapp: "+27639691493",
        whatsapp_agent_image_1: "https://static.getbutton.io/img/flag.jpg?v=1",
        whatsapp_agent_image_2: "https://static.getbutton.io/img/flag.jpg?v=1",
        whatsapp_agent_image_3: "https://static.getbutton.io/img/flag.jpg?v=1",
        whatsapp_agent_image_4: "https://static.getbutton.io/img/flag.jpg?v=1",
        whatsapp_agent_image_5: "https://static.getbutton.io/img/flag.jpg?v=1",
        whatsapp_popup_title: "Start a Conversation",
        whatsapp_popup_subtitle: "Click one of our members below to chat",
        call_to_action: "Chat with agent",
        ga: true,
        button_opacity: 50,
        shift_vertical: 40,
        domain: "moyhstation.shop",
        key: "KndjOLhhRrui5JLFfhVutg",
      };
      var proto = "https:",
        host = "getbutton.io",
        url = proto + "//static." + host;
      var s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = url + "/widget-send-button/js/init.js";
      s.onload = function () {
        WhWidgetSendButton.init(host, proto, options);
        // Apply theme styles after widget loads
        setTimeout(applyThemeStyles, 500);
      };
      var x = document.getElementsByTagName("script")[0];
      x.parentNode.insertBefore(s, x);
    })();
  }, []);

  // Apply theme styles when theme changes
  useEffect(() => {
    // Apply styles immediately
    applyThemeStyles();

    // Use MutationObserver to watch for widget DOM changes
    const observer = new MutationObserver(() => {
      applyThemeStyles();
    });

    // Observe the document body for widget insertion
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Also check periodically in case widget loads late
    const interval = setInterval(() => {
      applyThemeStyles();
    }, 2000);

    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, [isDarkMode, theme]);

  return null; // This component doesn't render anything, it just loads the script
};

export default WhatsAppWidget;
